import axios from 'axios';
import { serviceUrl } from '../../App';

export const getMasterAssignment = () => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment?where=true`
  );
};
export const deleteAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment/delete`,
    obj,
    {
      headers,
    }
  );
};
export const addAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment/add`,
    obj,
    {
      headers,
    }
  );
};
export const editAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment/update`,
    obj,
    {
      headers,
    }
  );
};
export const getAssignments = () => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment?where=false`
  );
};
export const getAssignmentsDetails = (id: any) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `assignment/team-trade-of-theAssignment?where=` +
      id
  );
};
export const setterTeamAndTradeToAssignment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL +
      `assignment/set-team-trade-of-theAssignment`,
    obj,
    { headers }
  );
};
export const clearAssignmentTeamId = (id: Object) => {
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `assignment/clear-team-id`,
    id
  );
};
